// Local translations
export const T = {
  en_GB: {
    headingTitle: "Heading Title",
    insertField: "Insert Field",
    clientFields: "Client Fields",
    customFields: "Custom Fields",
    quizFields: "Quiz Results",
    quizOverrideFields: "Quiz overrides",
    quizExternalFields: "Quiz external results",
    ownerFields: "Owner Fields",
    goalFields: "Goal Fields",
    portfolioFields: "Portfolio Fields",
    portfolioMandateStatus: "Portfolio Mandate Status",
    portfolioMandateDeviationNote: "Portfolio Mandate Deviation Note",
    portfolioMandateDecidedBy: "Portfolio Mandate Decided By",
    portfolioMandateDecidedAt: "Portfolio Mandate Decided At",
    portfolioModelDeviation: "Portfolio Model Deviation",
    portfolioModelRiskScore: "Portfolio Model Risk Score",
    portfolioGoalRiskScore: "Portfolio Goal Risk Score",
    flowFields: "Flow Fields",
    flow: "Flow",
    document: "Document",
    placeholder: "e.g., Investment Recommendation",
    autoNumbered: "Numbered 1, 2, 3 … when “Number headings” is on in the template’s Style tab.",
    nestingGoal:
      "In a per-goal section the first heading is the goal’s own entry (6.) and the headings after it nest under it (6.1, 6.2 …).",
    nestingPortfolio:
      "In a per-portfolio section the first heading is the portfolio’s own entry under its goal (6.4) and the headings after it nest under it (6.4.1 …). If the goal prints no heading, the portfolio’s headings take its place (6., 6.1 …).",
    textColor: "Color",
    reset: "Reset",
    default: "Default",
    goal: "Goal",
    portfolio: "Portfolio",
    // Client field labels
    name: "Name",
    cancelReason: "Cancel Reason",
    expectingChanges: "Expecting Financial Changes",
    expectingChangesNote: "Expecting Financial Changes Note",
    type: "Type",
    email: "Email",
    mobilePhone: "Mobile Phone",
    ssn: "SSN",
    orgId: "Org ID",
    country: "Country",
    groupMembers: "Group members",
    representative: "Representative",
    owner: "Owner",
    // Owner field labels
    phoneNumber: "Phone Number",
    title: "Title",
    signature: "Signature",
    // Goal field labels
    goalName: "Goal Name",
    portfolioName: "Portfolio Name",
    goalType: "Goal Type",
    goalDescription: "Goal Description",
    riskScore: "Risk Score",
    mandateName: "Mandate Name",
    mandateStatus: "Mandate Status",
    mandateSource: "Mandate Source",
    mandateOrigin: "Mandate Origin",
    mandateMode: "Mandate Mode",
    existingMandateName: "Existing Mandate Name",
    mandateDeviationNote: "Mandate Deviation Note",
    mandateDecidedBy: "Mandate Decided By",
    mandateDecidedAt: "Mandate Decided At",
    // Document fields
    today: "Today",
    // Validation
    validationError: "Please enter a heading title",
  },
  nb_NO: {
    headingTitle: "Overskrifttittel",
    insertField: "Sett inn felt",
    clientFields: "Kundefelt",
    customFields: "Egendefinerte felt",
    quizFields: "Quizresultater",
    quizOverrideFields: "Quiz-overstyringer",
    quizExternalFields: "Eksterne quiz-resultater",
    ownerFields: "Eierfelt",
    goalFields: "Målfelt",
    portfolioFields: "Porteføljefelt",
    portfolioMandateStatus: "Porteføljens mandatstatus",
    portfolioMandateDeviationNote: "Porteføljens mandatavvik begrunnelse",
    portfolioMandateDecidedBy: "Porteføljens mandatavvik akseptert av",
    portfolioMandateDecidedAt: "Porteføljens mandatavvik akseptert dato",
    portfolioModelDeviation: "Modellportefølje fra annen risikoscore",
    portfolioModelRiskScore: "Modellporteføljens risikoscore",
    portfolioGoalRiskScore: "Målets risikoscore",
    flowFields: "Flytfelt",
    flow: "Flyt",
    document: "Dokument",
    placeholder: "f.eks. Investeringsanbefaling",
    autoNumbered: "Nummereres 1, 2, 3 … når «Nummerer overskrifter» er på i malens Stil-fane.",
    nestingGoal:
      "I en seksjon per mål er den første overskriften målets egen oppføring (6.), og overskriftene etter den legges under den (6.1, 6.2 …).",
    nestingPortfolio:
      "I en seksjon per portefølje er den første overskriften porteføljens egen oppføring under målet (6.4), og overskriftene etter den legges under den (6.4.1 …). Skriver målet ingen overskrift, tar porteføljens overskrifter plassen (6., 6.1 …).",
    textColor: "Farge",
    reset: "Tilbakestill",
    default: "Standard",
    goal: "Mål",
    portfolio: "Portefølje",
    // Client field labels
    name: "Navn",
    cancelReason: "Kanselleringsårsak",
    expectingChanges: "Forventede økonomiske endringer",
    expectingChangesNote: "Notat om forventede endringer",
    type: "Type",
    email: "E-post",
    mobilePhone: "Mobiltelefon",
    ssn: "Fødselsnummer",
    orgId: "Org.nr",
    country: "Land",
    groupMembers: "Gruppemedlemmer",
    representative: "Representant",
    owner: "Eier",
    // Owner field labels
    phoneNumber: "Telefonnummer",
    title: "Tittel",
    signature: "Signatur",
    // Goal field labels
    goalName: "Målnavn",
    portfolioName: "Porteføljenavn",
    goalType: "Måltype",
    goalDescription: "Målbeskrivelse",
    riskScore: "Risikoscore",
    mandateName: "Mandatnavn",
    mandateStatus: "Mandatstatus",
    mandateSource: "Mandatkilde",
    mandateOrigin: "Mandatopprinnelse",
    mandateMode: "Mandatmodus",
    existingMandateName: "Eksisterende mandatnavn",
    mandateDeviationNote: "Mandatavvik begrunnelse",
    mandateDecidedBy: "Mandatavvik akseptert av",
    mandateDecidedAt: "Mandatavvik akseptert dato",
    // Document fields
    today: "I dag",
    // Validation
    validationError: "Vennligst skriv inn en overskrifttittel",
  },
} as const;
